import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsEmailRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-email',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
	exact: true,
};
